"use strict";
/* eslint-disable functional/no-expression-statement */
/* eslint-disable functional/no-conditional-statement */
/* eslint-disable functional/immutable-data */
/* eslint-disable functional/no-loop-statement */
/* eslint-disable functional/functional-parameters */
/* eslint-disable functional/no-return-void */
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPageStateMemory = void 0;
var createPageStateMemory = function () {
    // TODO constrain the size of these collections?
    // TODO persist these?
    // eslint-disable-next-line functional/prefer-readonly-type
    var locations = new Array();
    // eslint-disable-next-line no-restricted-globals
    var pageStateMap = new Map();
    var handlePushAction = function (previousLocationKey, nextLocationKey) {
        var desiredLocationsLength = locations.indexOf(previousLocationKey) + 1;
        while (locations.length > desiredLocationsLength) {
            var key = locations.pop();
            if (key !== undefined) {
                pageStateMap.delete(key);
            }
        }
        locations.push(nextLocationKey);
    };
    var handleReplaceAction = function (previousLocationKey, nextLocationKey) {
        var indexToReplace = locations.indexOf(previousLocationKey);
        if (indexToReplace !== -1) {
            locations[indexToReplace] = nextLocationKey;
        }
        pageStateMap.delete(previousLocationKey);
    };
    return {
        pageState: function (key) {
            return pageStateMap.get(key);
        },
        update: function (action, previousLocationKey, nextLocationKey, previousPageState) {
            pageStateMap.set(previousLocationKey, previousPageState);
            if (action === "PUSH") {
                handlePushAction(previousLocationKey, nextLocationKey);
            }
            else if (action === "REPLACE") {
                handleReplaceAction(previousLocationKey, nextLocationKey);
            }
        },
    };
};
exports.createPageStateMemory = createPageStateMemory;
